import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';
import { ResponsiveTypography } from '../../Typography/v3/ResponsiveTypography';

const Container = styled.div`
  display: grid;
  grid-row-gap: 4px;
  &.center {
    text-align: center;
  }
`;

interface ModalHeaderContentSimpleTextProps {
  text?: string;
  subText?: string;
  align?: 'left' | 'center';
}

export const ModalHeaderContentSimpleText = (props: ModalHeaderContentSimpleTextProps) => {
  const { text, subText, align = 'left' } = props;

  return (
    <Container className={cl('modal-header-content-simple-text', align)}>
      <ResponsiveTypography.Paragraph className="text" variant="semi-bold/20-28" color="black100">
        {text}
      </ResponsiveTypography.Paragraph>
      {subText && (
        <ResponsiveTypography.Paragraph
          className="sub-text"
          variant="regular/14-20"
          color="black80"
        >
          {subText}
        </ResponsiveTypography.Paragraph>
      )}
    </Container>
  );
};
